// @flow strict
import type { Theme } from './theme-loader.js';

const defaultTheme: Theme = {
  getLogo: () => {
    return null;
  },
  getWelcomePanelOverrideStyle: (): string => {
    return '';
  }
};

export default defaultTheme;
